import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kind", "bodyParts"]

  connect() {
    this.updateBodyParts()
  }

  updateBodyParts() {
    const injury = this.kindTarget.value === "Injury"
    this.bodyPartsTarget.hidden = !injury
    this.bodyPartsTarget.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.disabled = !injury
    })
  }
}
